export default {
    "piece": "piece",
    "milligram": "mg",
    "gram": "g",
    "kilogram": "kg",
    "ton": "ton",
    "millimeter": "mm",
    "centimeter": "cm",
    "meter": "m",
    "kilometer": "km",
    "milliliter": "mL",
    "liter": "L",
    "cubic_meter": "m³",
}